<template>
  <div class="contact-container">
    <div v-for="i in 200">联系我们{{ i }}</div>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {};
  },
  created() {},
  watch: {},
};
</script>

<style lang="less" scoped>
.contact-container {
  min-height: calc(100vh - 60px - 360px);
}
</style>
